import { useCallback } from "react";
import { useController, useFormContext, useWatch } from "react-hook-form";
import { uploadClaimAttachment } from "./FilePicker/useClaimAttachmentFiles.js";
import ClaimCostsEditor from "../../claim/costs/ClaimCostsEditor.jsx";
import {
  useFormAttachments,
  useFormCoverage,
  useFormEditMode,
  useFormModel,
} from "../FormDefinitionRenderer/contexts.js";
import { COVERAGE_TYPES_FIELD } from "../FormDefinitionRenderer/coverageSelection.js";
import { effectiveCostTypes } from "../FormDefinitionRenderer/costEditorScopes.js";

export default function ClaimCostsEditorControl({ item }) {
  const model = useFormModel();
  const isEditMode = useFormEditMode();
  const attachments = useFormAttachments();
  const { control, setValue } = useFormContext();
  const { objektSparten } = useFormCoverage();
  const [selectedIds, sparteId] = useWatch({
    control,
    name: [COVERAGE_TYPES_FIELD, "sparte_id"],
  });
  const costTypes = effectiveCostTypes(item, {
    objektSparten,
    selectedIds,
    sparteId,
  });

  const { field } = useController({
    name: item.name,
    control,
    defaultValue: [],
  });

  const uploadFn = useCallback(
    (file, uuid, description) =>
      uploadClaimAttachment(model?.id, file, uuid, description),
    [model?.id]
  );

  const handleAddSessionFile = useCallback(
    (file) => attachments?.addSessionAttachmentFile(file, uploadFn),
    [attachments?.addSessionAttachmentFile, uploadFn]
  );

  const handleFormChange = useCallback(
    ({ target: { name, value } }) =>
      setValue(name, value, {
        shouldDirty: false,
        shouldValidate: name === item.amount_field,
      }),
    [setValue, item.amount_field]
  );

  return (
    <ClaimCostsEditor
      disabled={!isEditMode}
      value={field.value ?? []}
      onChange={field.onChange}
      onFormChange={handleFormChange}
      onFormOpenChange={null}
      amountField={item.amount_field}
      costTypes={costTypes}
      claimId={model?.id}
      claimAttachmentFiles={attachments?.claimAttachmentFiles ?? []}
      sessionAttachmentFiles={attachments?.sessionAttachmentFiles ?? []}
      addSessionAttachmentFile={handleAddSessionFile}
      updateSessionAttachmentFileDescription={
        attachments?.updateSessionAttachmentFileDescription
      }
      getUuidForServerId={attachments?.getUuidForServerId ?? (() => null)}
      clearSessionAttachments={
        attachments?.clearSessionAttachments ?? (() => {})
      }
    />
  );
}
